/* eslint-disable functional/immutable-data */

import { ApplePayCheckout, ApplePaySetAsDefaultButton } from './components';

export const ApplePay = () => {
  return null;
};

ApplePay.Checkout = ApplePayCheckout;
ApplePay.SetAsDefaultButton = ApplePaySetAsDefaultButton;
